import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { fakeTableList, steps } from "./parts";
import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { funInfoBodyList } from "./hooks/useHooks";
import TkButton from "../../components/atoms/TkButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMemo from "../../components/molecules/TkMemo";
import { Box } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { GlobalContext } from "../../context/globalContext";
import TkStepper from "../../components/atoms/TkStepper";
import { httpAPI_APP016, httpAPI_CON024 } from "./api/request";
import { IAPI_APP016_Request } from "../../type/apiType";
import { BusinessContext } from "../../context/businessContext";
import { applyEvent, Prefectures } from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";
import TkBackButton from "../../components/molecules/TkBackButton";

/**
 * SCRW030001_社会福施設職員等退職手当共済制度　共済契約のお申込み
 * @returns SCRW030001_社会福施設職員等退職手当共済制度　共済契約のお申込み
 */
const SCRW030001 = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const [stateContractInfoList, setStateContractInfoList] = useState<any>([]);
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>([]);
  const [reason, setReason] = useState("");
  const [checkValue, setCheckValue] = useState<string | undefined>();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const { state: businessState } = useContext(BusinessContext);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const stateFakeTableList = stateFakeTableListRef.current;

  async function openingScreen() {
    try {
      // 契約者申請情報参照API実行
      const res = await httpAPI_CON024({
        applyId: locationState?.applyId,
      });

      let resArr = stateFakeTableList;

      if (res.resultCd === "I0000") {
        // 初期表示
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.setDefaultValue = res[i as keyof typeof res]);
          if (i === "managerEmail") {
            targetObj = resArr.find((item) => item.keyword === "emailConfirm")!;
            targetObj && (targetObj.setDefaultValue = res[i]);
          }
        }

        resArr.find((item) => item.keyword === "mainFacilityKinds")!.text =
          res.facilityKind;

        setStatusInfoTableList(funInfoBodyList(res.statusList));

        const resObj = {
          prefectures: TkGetCode(Prefectures, res.prefectureCd),
          city: res.city || "",
          address: res.addressOther || "",
        };
        resArr.find((item) => item.keyword === "address")!.valueObject = resObj;
        setStateContractInfoList([...resArr]);
        setShowButton(res["latestApplyStatus"] === "08");
        setActiveStep(res["latestApplyStatus"] === "13" ? 1 : 0);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }
  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* リクエストパラメータ作成*/
  const makeHttpObj = (): IAPI_APP016_Request => {
    const reqObj: IAPI_APP016_Request = {
      applyId: locationState?.applyId,
      applyEvent: applyEvent["契約者に差戻し"],
      contractorNo: businessState.common?.contractorNo,
      applyDate: "",
      inquiryCode: checkValue,
      reason: reason,
    };

    return reqObj;
  };

  const makeStatus = async (date: any) => {
    handleOk("submit", date);
  };

  const onCheckAndSubmit = async (type: "submit" | "decline") => {
    switch (type) {
      case "submit":
        setOpenSuccess(true);
        break;
      case "decline":
        handleOk("decline");
    }
  };

  const handleOk = async (btnName: string, date?: any) => {
    if (btnName === "submit") {
      navigate("/SCRW130001", {
        state: {
          applyId: locationState?.applyId,
          contractorNo: businessState.common?.contractorNo,
          contractDate: date,
          refInquiryScreen: checkValue,
          screenId: "SCRW030001",
          memo: reason,
          updateTime: "",
        },
      });
    } else
      try {
        // 申請状況更新API実行
        const res = await httpAPI_APP016({
          ...makeHttpObj(),
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });
          navigate("/SCRW110001");
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
  };

  const handleCancel = () => {
    setOpenSuccess(false);
  };

  return (
    <Box data-testid="SCRW030001PageForTest" className="tkSCRW030001">
      <TkStepper steps={steps} activeStep={activeStep} />
      {/* TkInfoManualを表示 */}
      <TkInfoManual children={labelids.labelid.LBLW030001_01} rule={"\\n"} />
      {/* TkFakeTableを表示 */}
      <TkFakeTable
        list={stateContractInfoList}
        ruleSchema={{}}
        disabled={true}
        showButton={false}
      />
      {/* メモ部品を表示 */}
      <TkMemo
        bodyList={statusInfoTableList}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          e.target.type === "input"
            ? setReason(e.target.value)
            : setCheckValue(e.target.value ? "1" : undefined)
        }
      ></TkMemo>

      {/* 通知/契約者に差戻しボタンを表示 */}
      <Box className="tkBtn">
        <TkBackButton mr />
        {showButton && (
          <>
            <TkButton mr onClick={() => onCheckAndSubmit("decline")}>
              契約者に差戻し
            </TkButton>

            <TkButton onClick={() => onCheckAndSubmit("submit")}>通知</TkButton>
          </>
        )}
      </Box>
      {/* ダイアログの表示 */}
      <TkDateDialog
        open={openSuccess}
        onOky={(date: any) => makeStatus(date)}
        onCancel={handleCancel}
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        title="契約申込日入力"
        okText="登録"
        cancelText="キャンセル"
        contextText="　契約申込日を入力してください。"
      />
    </Box>
  );
};
export default SCRW030001;
